import React, { useEffect, useState } from 'react';
import { listUsers, deleteUser, createUser } from '../controllers/usersController';

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortBy, setSortBy] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState('desc');

  const fetch = async () => {
    setLoading(true);
    try {
      const res = await listUsers({ page: 1, limit: 50, sortBy, sortOrder });
      setUsers(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetch(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete user?')) return;
    try { await deleteUser(id); await fetch(); } catch (e) { setError(e.message); }
  };

  return (
    <div style={{ width: '100%', maxWidth: '100%' }}>
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ 
          margin: '0 0 8px 0', 
          color: 'var(--text-primary)', 
          fontSize: '2rem',
          fontWeight: '700'
        }}>
          Users
        </h1>
        <p style={{ 
          margin: '0', 
          color: 'var(--text-secondary)', 
          fontSize: '1rem' 
        }}>
          Manage and view all registered users
        </p>
      </div>

      {error && (
        <div style={{
          background: 'rgba(255, 99, 99, 0.1)',
          border: '1px solid rgba(255, 99, 99, 0.2)',
          borderRadius: 'var(--border-radius-sm)',
          padding: '12px 16px',
          marginBottom: '24px',
          color: '#ff6363',
          fontSize: '0.9rem'
        }}>
          {error}
        </div>
      )}

      <div style={{ 
        display: 'flex', 
        gap: '16px', 
        alignItems: 'center', 
        marginBottom: '24px',
        flexWrap: 'wrap'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ 
            color: 'var(--text-secondary)', 
            fontSize: '0.9rem',
            fontWeight: '500'
          }}>
            Sort by:
          </label>
          <select 
            value={sortBy} 
            onChange={(e) => setSortBy(e.target.value)}
            style={{
              padding: '8px 12px',
              background: 'var(--input-bg)',
              border: '1px solid var(--card-border)',
              borderRadius: 'var(--border-radius-sm)',
              color: 'var(--text-primary)',
              fontSize: '0.9rem'
            }}
          >
            <option value="total_units_played">Units Played</option>
            <option value="total_amount_spent">Amount Spent</option>
            <option value="createdAt">Created At</option>
          </select>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <label style={{ 
            color: 'var(--text-secondary)', 
            fontSize: '0.9rem',
            fontWeight: '500'
          }}>
            Order:
          </label>
          <select 
            value={sortOrder} 
            onChange={(e) => setSortOrder(e.target.value)}
            style={{
              padding: '8px 12px',
              background: 'var(--input-bg)',
              border: '1px solid var(--card-border)',
              borderRadius: 'var(--border-radius-sm)',
              color: 'var(--text-primary)',
              fontSize: '0.9rem'
            }}
          >
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
          </select>
        </div>

        <button 
          className="button-secondary" 
          onClick={fetch}
          style={{ marginLeft: 'auto' }}
        >
          Refresh
        </button>
      </div>

      {loading ? (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '60px 20px',
          color: 'var(--text-secondary)',
          fontSize: '1rem'
        }}>
          Loading users...
        </div>
      ) : (
        <div style={{
          background: 'var(--card-bg)',
          border: '1px solid var(--card-border)',
          borderRadius: 'var(--border-radius-lg)',
          overflow: 'hidden',
          boxShadow: 'var(--neon-glow)'
        }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse',
            margin: 0
          }}>
            <thead>
              <tr style={{
                background: 'rgba(255, 255, 255, 0.02)',
                borderBottom: '1px solid var(--card-border)'
              }}>
                <th style={{
                  padding: '16px 20px',
                  textAlign: 'left',
                  color: 'var(--text-primary)',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>Name</th>
                <th style={{
                  padding: '16px 20px',
                  textAlign: 'left',
                  color: 'var(--text-primary)',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>Phone</th>
                <th style={{
                  padding: '16px 20px',
                  textAlign: 'left',
                  color: 'var(--text-primary)',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>Units Played</th>
                <th style={{
                  padding: '16px 20px',
                  textAlign: 'left',
                  color: 'var(--text-primary)',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>Amount Spent</th>
                <th style={{
                  padding: '16px 20px',
                  textAlign: 'left',
                  color: 'var(--text-primary)',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>Created</th>
                <th style={{
                  padding: '16px 20px',
                  textAlign: 'center',
                  color: 'var(--text-primary)',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u, index) => (
                <tr 
                  key={u._id} 
                  style={{ 
                    borderBottom: index < users.length - 1 ? '1px solid rgba(255,255,255,0.04)' : 'none'
                  }}
                >
                  <td style={{
                    padding: '16px 20px',
                    color: 'var(--text-primary)',
                    fontSize: '0.95rem',
                    fontWeight: '500'
                  }}>
                    {u.name}
                  </td>
                  <td style={{
                    padding: '16px 20px',
                    color: 'var(--text-secondary)',
                    fontSize: '0.95rem',
                    fontFamily: 'monospace'
                  }}>
                    {u.phone}
                  </td>
                  <td style={{
                    padding: '16px 20px',
                    color: 'var(--text-primary)',
                    fontSize: '0.95rem',
                    textAlign: 'center'
                  }}>
                    <span style={{
                      background: 'rgba(0, 229, 255, 0.1)',
                      color: 'var(--accent)',
                      padding: '4px 8px',
                      borderRadius: 'var(--border-radius-sm)',
                      fontSize: '0.85rem',
                      fontWeight: '600'
                    }}>
                      {u.total_units_played ?? 0}
                    </span>
                  </td>
                  <td style={{
                    padding: '16px 20px',
                    color: 'var(--text-primary)',
                    fontSize: '0.95rem',
                    textAlign: 'center'
                  }}>
                    <span style={{
                      background: 'rgba(155, 89, 255, 0.1)',
                      color: 'var(--accent-2)',
                      padding: '4px 8px',
                      borderRadius: 'var(--border-radius-sm)',
                      fontSize: '0.85rem',
                      fontWeight: '600'
                    }}>
                      ₹{u.total_amount_spent ?? 0}
                    </span>
                  </td>
                  <td style={{
                    padding: '16px 20px',
                    color: 'var(--text-secondary)',
                    fontSize: '0.9rem'
                  }}>
                    {new Date(u.createdAt).toLocaleDateString('en-IN', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric'
                    })}
                  </td>
                  <td style={{
                    padding: '16px 20px',
                    textAlign: 'center'
                  }}>
                    <button 
                      className="button-danger" 
                      onClick={() => handleDelete(u._id)}
                      style={{
                        padding: '6px 12px',
                        fontSize: '0.8rem',
                        borderRadius: 'var(--border-radius-sm)'
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {users.length === 0 && (
            <div style={{
              padding: '60px 20px',
              textAlign: 'center',
              color: 'var(--text-secondary)',
              fontSize: '1rem'
            }}>
              No users found
            </div>
          )}
        </div>
      )}
    </div>
  );
}
